export default __webpack_public_path__ + "css/app.css";